const defaultState = [];

export const favoritesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'UPDATE_FAVORITES':
      return action.payload;

    default:
      return state;
  }
};